import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const quickAddDrawerSwiper = (
  swiperSelector,
  slidesPerView,
  spaceBetween,
  nextEl,
  prevEl,
  scrollbarEl = null,
) => {
  return new Swiper(swiperSelector, {
    slidesPerView: slidesPerView,
    spaceBetween: spaceBetween,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    ...(scrollbarEl && {
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        hide: false,
      },
    }),
  });
};

export { quickAddDrawerSwiper };
